import { render, staticRenderFns } from "./facet-list-group-minimal.vue?vue&type=template&id=5f3d8b20&"
import script from "./facet-list-group-minimal.vue?vue&type=script&lang=js&"
export * from "./facet-list-group-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports